import useNav from "../../../uses/useNav";
import MyMDBox from "../../../components/MyMDBox";
import MyMDButton from "../../../components/MyMDButton";
import MyTableStyle from "../../../examples/MyTableStyle";
import { useEffect, useState } from "react";
import { T_elevError } from "../../../models/error";
import apis from "../../../apis";
import MyMDTypography from "../../../components/MyMDTypography";


function ElevError({elevatorNo}:any){
//    console.log(elevatorNo);
    const nav = useNav();
    const [errorList,setErrorList] = useState<T_elevError[]>([]);
      const getElevatorError = async() => {
          const result = await apis.elevator.getElevErrorList({elevatorNo:elevatorNo,pagesize:3});
          console.log("result:",result);
          if(result.isSuccess){
              setErrorList(result.data);
          }
  
      }

    useEffect(()=>{
        getElevatorError();
    },[])  
    return(
        <MyTableStyle 
        style={{width:'100%',marginBottom:10}}
        header={{
          title: "최근에러현황",
          rightComponent: (
            <MyMDBox
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <MyMDButton
                onClick={(evt: any) => {
                  evt.preventDefault();
                  nav.pushParam(`/error`,{elevatorNo:elevatorNo});
                  
                }}
                href="#"
                component="a"
                rel="noreferrer"
                variant="gradient"
                color="light"
              >
                에러더보기
              </MyMDButton>
            </MyMDBox>
          ),
        }}
        table={(() => {
          type column = "에러넘버" | "내용" | "일시";
          type low = {
            [name in column]: JSX.Element;
          };
          const columnList: column[] = [
            "에러넘버",
            "내용",
            "일시",
          ];

          return {
            columns: columnList.map((column) => {
              let width = "";
              switch (column) {
                case "에러넘버": {
                  width = "30%";
                  break;
                }
                case "내용": {
                  width = "40%";
                  break;
                }
                case "일시": {
                  width = "30%";
                  break;
                }
              }

              return {
                Header: column,
                accessor: column,
                width,
              };
            }),
            rows: errorList && errorList.map((error, idx) => {
              const row: low = {
                ["에러넘버"]: (
                  <MyMDBox
                    onClick={(evt: any) => {
                      evt.preventDefault();
                     // nav.push(`/elevator/${checkingElevator.elevinfo}`);
//                        nav.pushParam('/elevator/info',{elevatorNo:checkingElevator.elevatorNo});
                    }}
                    href="#"
                    component="a"
                    alignItems="center"
                  >
                    <MyMDTypography display="block" variant="caption" fontWeight="medium" mb={1}>
                      {/* 602동 1호기 */}
                    </MyMDTypography>
                    <MyMDTypography
                      display="block"
                      variant="caption"
                      fontWeight="regular"
                      color="text"
                    >
                      {error.errorCode}
                    </MyMDTypography>
                  </MyMDBox>
                ),
                ["내용"]: (
                  <MyMDTypography
                    display="block"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                  {error.errorinfo?error.errorinfo.title:""}
                  </MyMDTypography>
                ),
                ["일시"]: (
                  <MyMDTypography
                    display="block"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                    {error.wdate}
                  </MyMDTypography>
                )
              };
              return row;
            }),
          };
        })()}
      />                 


    )
}
export default ElevError;
